export const odpiralniCas = [
  {
    id: "pon",
    dnevi: "Ponedeljek",
    ure: "06.00 – 22.00",
    potrjeno: true,
  },
  {
    id: "tor",
    dnevi: "Torek",
    ure: "06.00 – 22.00",
    potrjeno: true,
  },
  {
    id: "sre",
    dnevi: "Sreda",
    ure: "06.00 – 22.00",
    potrjeno: true,
  },
  {
    id: "cet",
    dnevi: "Četrtek",
    ure: "06.00 – 22.00",
    potrjeno: true,
  },
  {
    id: "pet",
    dnevi: "Petek",
    ure: "06.00 – 24.00",
    potrjeno: true,
  },
  {
    id: "sob",
    dnevi: "Sobota",
    ure: "06.00 – 24.00",
    potrjeno: true,
  },
  {
    id: "ned",
    dnevi: "Nedelja",
    ure: "07.00 – 20.00",
    potrjeno: true,
  },
];

export const kontakt = {
  naslov: "Zadružni trg 12D, 2250 Ptuj, Slovenija",
  naslovKratek: "Zadružni trg 12D, Ptuj",
  googleMaps:
    "https://www.google.com/maps/search/?api=1&query=Zadru%C5%BEni%20trg%2012D%2C%202250%20Ptuj%2C%20Slovenija",
  navigacija:
    "https://www.google.com/maps/dir/?api=1&destination=Zadru%C5%BEni%20trg%2012D%2C%202250%20Ptuj%2C%20Slovenija",
  zemljevid:
    "https://www.google.com/maps?q=Zadru%C5%BEni%20trg%2012D%2C%202250%20Ptuj%2C%20Slovenija&hl=sl&z=17&output=embed",
  facebook:
    "https://www.facebook.com/search/pages/?q=Stanka%20Bar%20Ptuj",
  instagram:
    "https://www.instagram.com/explore/search/keyword/?q=Stanka%20Bar%20Ptuj",
};